import React from 'react'
import { DeletePatient } from './DeletePatient';
import { FormUpdateBusinessName } from './FormUpdateBusinessName';
import './StyleModalPatients.css'
import { Dialog } from 'primereact/dialog';
import { GlobalFormPatient } from './GlobalFormPatient'
import { Button } from 'reactstrap'

export const ModalPatient = (props) => {

    const {

        // ? ACTIONS OF THE MODAL
        toggle, modalTitle, method, loading, closeModalPatient, modal,

        // ? ACTIONS OF THE INPUTS
        handleInputChange, handleSelectValues, handleChangeState, handleChangeTaxRegime, handleChangeSocialGender, handleDateB, getAge,
        handleChangeTypePerson,

        // ? FIELD
        id_gender, id_state, id_municipality, id_blood_type, id_social_gender, id_tax_regime, id_social_gender_patient,
        id_use_cfdi, rfc, paternal_surname, maternal_surname, name, birthday, age,
        curp, address, cp, colony, phone, email, membership, cardnumber, expedient_number, nss, matricula_buap, type_person,

        // ? CATALOGS
        listStates, listMunicipalities, listBloodType, listTaxRegime, listUseCfdi, listSocialGender,

        // ? DYNAMIC FORM
        listConfiguration, fieldErrors,

        // ? VALIDATION INVOICE
        validationsPatient, tax_regime_patient, business_name, handleChangeTypePatient,

        // ? SAVE METHODS
        savePatient, saveUpdate, saveDelete, whatsapp_numbers, handleWhatsappChange, validateWhatsapp,

    } = props;



    return (
        <Dialog
            visible={modal}
            onHide={
                method === "updateBusinessNamePatient"
                    ? () => toggle("PATIENT")
                    : closeModalPatient
            }
            modal
            closable={true}
            dismissableMask={false}
            className={method === "delete" ? "medium-dialog delete-method" : "extra-large-dialog-company"}
            header={
                <div className="custom-dialog-header">
                    <div className="header-left">
                        <i className="fa fa-user-circle header-icon"></i>
                        <span className="header-title">{modalTitle}</span>
                    </div>
                </div>
            }
            blockScroll={true}
            footer={
                <>
                    {
                        method === "delete" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveDelete}
                            disabled={loading}
                        >
                            {loading ? "Eliminando" ?? "--" : "Eliminar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "updateBusinessNamePatient" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveUpdate}
                            disabled={loading}
                        >
                            {loading ? "Guardando" ?? "--" : "Guardar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "updateBusinessNamePatient" && <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={() => toggle("PATIENT")}
                            disabled={loading}
                        >
                            {loading ? "Cancelar" ?? "--" : "Cancelar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "create" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={savePatient}
                            disabled={loading}
                        >
                            {loading ? "Guardando" ?? "--" : "Guardar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "updateData" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveUpdate}
                            disabled={loading}
                        >
                            {loading ? "Actualizar" ?? "--" : "Actualizar" ?? "---"}
                        </Button>
                    }
                    {
                        method !== "updateBusinessNamePatient" && <Button
                            size="sm"
                            type="button"
                            color="danger"
                            className="btn-air-light"
                            onClick={toggle}
                            disabled={loading}
                        >
                            {"Cancelar" ?? "---"}
                        </Button>
                    }
                </>
            }
        >
            {
                (method === "create" || method === "updateData")
                    ?
                    <GlobalFormPatient
                        button={method === "create" ? "Guardar" : "Actualizar"}
                        {
                        ...{
                            // ? ACTIONS OF THE INPUTS
                            handleInputChange, handleSelectValues, handleChangeState, handleChangeTaxRegime, handleChangeSocialGender, handleDateB, getAge,
                            handleChangeTypePerson,

                            // ? FIELD
                            id_gender, id_state, id_municipality, id_blood_type, id_social_gender, id_tax_regime,
                            id_use_cfdi, rfc, paternal_surname, maternal_surname, name, birthday, age,
                            curp, address, cp, colony, phone, email, membership, cardnumber, expedient_number, nss, matricula_buap, type_person,

                            // ? CATALOGS
                            listStates, listMunicipalities, listBloodType, listTaxRegime, listUseCfdi, listSocialGender,

                            // ? DYNAMIC FORM
                            listConfiguration, fieldErrors, whatsapp_numbers, handleWhatsappChange, validateWhatsapp
                        }
                        }
                    />

                    : (method === "delete")
                        ?
                        <DeletePatient
                            {
                            ...{
                                toggle, loading, paternal_surname, maternal_surname, name
                            }
                            }
                        />

                        : (method === "updateBusinessNamePatient")
                            ?
                            <FormUpdateBusinessName
                                {
                                ...{
                                    handleInputChange, loading, listTaxRegime,
                                    rfc_patient: rfc, type_person_patient: type_person, id_tax_regime_patient: id_tax_regime,
                                    cp_patient: cp, validationsPatient, email, business_name, expedient_number,
                                    saveUpdatePatient: saveUpdate, tax_regime_patient, toggle, handleChangeTypePatient
                                }
                                }
                            />
                            : ""
            }
        </Dialog >
    )
}
